import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full rounded-md mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex animate-pulse flex-row items-center justify-start p-3 space-x-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 bg-gray-300 h-10 rounded-full" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-3 w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-2/2 bg-gray-300 h-6 rounded-md" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}